import { version } from '@pdftron/webviewer/package.json'

// WebViewer runtime folder, filled by bin/setup-pdftron from the same package.
export const PDFTRON_PATH = `/pdftron/${version}`
